/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

export class MimeTypes {
  static images: string[] = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
  static archives: string[] = ['tgz', 'war', 'rar', 'zip', '7zip', 'rar'];
  static application: string[] = ['pdf'];
  static getExtension(filename: string): string {
    const split = filename.split('.');
    return split[split.length - 1].toLowerCase();
  }
  static lookup(filename: string) {
    const extension = MimeTypes.getExtension(filename);
    if (MimeTypes.isImage(extension)) {
      return 'images/' + extension;
    } else if (MimeTypes.isApplication(extension)) {
      return 'application/' + extension;
    }
    return undefined;
  }
  static isImage(extension: string) {
    return (
      MimeTypes.images.findIndex((type) => {
        return type === extension;
      }) >= 0
    );
  }

  static isApplication(extension: string) {
    return (
      MimeTypes.application.findIndex((type) => {
        return type === extension;
      }) >= 0
    );
  }
}
